import './style.scss'
import './app.scss'
import 'floating-vue/dist/style.css'

import FloatingVue from 'floating-vue'

import { createRouter } from './router/router'
import App from './App.vue'
import { keys } from './injection-keys'
import * as clientSideStored from './util/client-side-stored'

// The initialization function of the plugin, receiving a target element
// and the options defined in the config file as <App> root props.
export default async function (
  element: Element | string,
  options: OwnbitConfigurator.PluginOptions,
) {
  const app = createApp(App)
  app.use(createPinia())
  app.provide(keys.options, options)

  const { defineStores } = await import('@/steps-meta/register-stores')
  app.runWithContext(() => {
    defineStores()
  })

  if (process.env.NODE_ENV === 'development') {
    const { useDummy } = await import('@/dummy/use-dummy')
    const requestMeta = useRequestMetaStore()
    const getDummyData = useDummy()

    Object.assign(window, {
      getDummyData,
      dummy({
        clearUuid = true,
        data = {},
      }: {
        clearUuid?: boolean
        data?: Partial<OwnbitConfigurator.AggregateStorableState>
      } = {}) {
        const fullData = getDummyData(data)
        const sessionStorageKey = clientSideStored.getKey(clearUuid ? undefined : requestMeta.uuid)
        sessionStorage.setItem(sessionStorageKey, JSON.stringify(fullData))

        const url = new URL(window.location.href)
        if (!clearUuid || !url.searchParams.has('r')) {
          window.location.reload()
        } else {
          url.searchParams.delete('r')
          window.location.assign(url)
        }
      },
    })
  }

  // Load saved state
  useSavedStateStore().load(
    clientSideStored.get(options.meta.uuid ?? undefined) ?? options.savedState ?? undefined,
  )

  app.use(FloatingVue)
  app.use(createRouter())

  // Mount application
  app.mount(element)

  // Make apiFetch function use the provided nonce
  if (options.nonce) {
    import('@wordpress/api-fetch').then(({ default: apiFetch }) => {
      apiFetch.use(apiFetch.createNonceMiddleware(options.nonce!))
    })
  }
}
